import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Button } from "@material-ui/core";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";

const SettingButton = styled(Button)`
  height: 40px;
  margin: 1em 1em 2em 1em;
`;

interface IIntegrationAddButtonProps extends RouteComponentProps {
  onClick: () => void;
}

const IntegrationAddButton = (props: IIntegrationAddButtonProps) => {
  const { onClick } = props;

  return (
    <SettingButton onClick={onClick} variant="outlined" color="primary" size="large" startIcon={<AddIcon />}>
      Add New
    </SettingButton>
  );
};

export default withRouter(IntegrationAddButton);
